import { render, staticRenderFns } from "./EventBoard.vue?vue&type=template&id=136dd5be&scoped=true"
import script from "./EventBoard.vue?vue&type=script&lang=js"
export * from "./EventBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136dd5be",
  null
  
)

export default component.exports